import { c as _c } from "react/compiler-runtime";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import { usePathname } from 'next/navigation';
import { type FC, type ReactNode } from 'react';
interface SideMenuItemProps {
  isMenuOpen: boolean;
  icon: ReactNode;
  children: string;
  route: string;
}
export const SideMenuItem: FC<SideMenuItemProps> = t0 => {
  const $ = _c(38);
  const {
    isMenuOpen,
    icon,
    children,
    route
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== route) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\?.*$/;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = route.replace(t2, "");
    $[0] = route;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cleanRoute = t1;
  let t2;
  if ($[3] !== cleanRoute || $[4] !== pathname) {
    t2 = cleanRoute === "/" ? pathname === "/" : pathname === cleanRoute || pathname.startsWith(`${cleanRoute}/`);
    $[3] = cleanRoute;
    $[4] = pathname;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isActive = t2;
  let t3;
  if ($[6] !== isActive) {
    t3 = theme => ({
      display: "block",
      backgroundColor: isActive ? theme.palette.primary.dark : undefined,
      "&:hover": {
        backgroundColor: theme.palette.primary.altern
      }
    });
    $[6] = isActive;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      popper: {
        modifiers: [{
          name: "offset",
          options: {
            offset: [0, -10]
          }
        }]
      }
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isMenuOpen ? "initial" : "center";
  let t6;
  if ($[9] !== t5) {
    t6 = {
      minHeight: 55,
      justifyContent: t5,
      px: 2.5
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isActive || $[12] !== isMenuOpen) {
    t7 = t8 => {
      const {
        palette
      } = t8;
      return {
        minWidth: 0,
        mr: isMenuOpen ? 3 : "auto",
        justifyContent: "center",
        color: isActive ? palette.secondary.light : palette.getContrastText(palette.primary.main)
      };
    };
    $[11] = isActive;
    $[12] = isMenuOpen;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== icon || $[15] !== t7) {
    t8 = <ListItemIcon sx={t7}>{icon}</ListItemIcon>;
    $[14] = icon;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = isMenuOpen ? 1 : 0;
  let t10;
  if ($[17] !== t9) {
    t10 = {
      opacity: t9
    };
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = isActive ? "secondary.light" : "white";
  let t12;
  if ($[19] !== t11) {
    t12 = {
      fontWeight: 600,
      color: t11,
      fontSize: 16
    };
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== children || $[22] !== t10 || $[23] !== t12) {
    t13 = <ListItemText sx={t10} primaryTypographyProps={t12}>{children}</ListItemText>;
    $[21] = children;
    $[22] = t10;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isActive || $[26] !== route || $[27] !== t13 || $[28] !== t6 || $[29] !== t8) {
    t14 = <ListItemButton sx={t6} selected={isActive} href={route}>{t8}{t13}</ListItemButton>;
    $[25] = isActive;
    $[26] = route;
    $[27] = t13;
    $[28] = t6;
    $[29] = t8;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== children || $[32] !== isMenuOpen || $[33] !== t14) {
    t15 = <Tooltip title={children} placement="right" disableHoverListener={isMenuOpen} componentsProps={t4}>{t14}</Tooltip>;
    $[31] = children;
    $[32] = isMenuOpen;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15 || $[36] !== t3) {
    t16 = <ListItem disablePadding={true} sx={t3} divider={true}>{t15}</ListItem>;
    $[35] = t15;
    $[36] = t3;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
};